import Sortable from 'sortablejs'

import './select-sortable.css'

const sort = Symbol('sort')

export default {
  install(Vue) {
    Vue.directive('select-sortable', {
      bind($el, binding, vnode) {
        const tagsWrapper = $el.querySelectorAll('.el-select__tags > span')[0]

        $el.classList = $el.classList + ' drag-select'

        $el[sort] = Sortable.create(tagsWrapper, {
          ghostClass: 'sortable-ghost',

          onEnd: evt => {
            const value = vnode.context.value
            const targetRow = value.splice(evt.oldIndex, 1)[0]
            value.splice(evt.newIndex, 0, targetRow)
          }
        })
      }
    })
  },
  unbind($el) {
    $el[sort].destroy()
  }
}
